var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "lazyImg", staticClass: "lazy-img", style: _vm.customStyle },
    [
      _c(
        "div",
        { ref: "padding", staticClass: "padding", style: _vm.customStyle },
        [
          _c("img", {
            attrs: {
              src: _vm.GLOBAL_default_seat,
              width: _vm.paddingImgWidth,
              alt: "图片占位图",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "targetImg",
          staticClass: "lazy-img-wrap",
          style: [
            ..._vm.customStyle,
            _vm.isRenderGroundGlassBgImg && { backgroundColor: "transparent" },
          ],
        },
        [
          _c("img", {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: _vm.lazyloadOptions,
                expression: "lazyloadOptions",
              },
            ],
            class: _vm.imgClass,
            style: { "object-fit": _vm.mode || "initial" },
            attrs: { src: "主图" },
          }),
          _vm._v(" "),
          _vm.isRenderGroundGlassBgImg
            ? _c("div", { staticClass: "glass-effect-img-wrapper" }, [
                _c("img", {
                  staticClass: "glass-effect-img",
                  attrs: { src: _vm.src, alt: "毛玻璃效果背景图片" },
                }),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }